import Loader from "./Loader";

interface AskQzModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    response: string;
    loading: boolean;
    onMessageChange: (message: string) => void;
    onSubmit: () => void;
  }
  
  export const AskQzModal: React.FC<AskQzModalProps> = ({
    isOpen,
    onClose,
    message,
    response,
    loading,
    onMessageChange,
    onSubmit
  }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50">
        <div className="fixed inset-0" onClick={onClose}>
          <div 
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-md mx-4"
            onClick={e => e.stopPropagation()}
          >
            <div className="bg-white rounded-xl shadow-2xl">
              <div className="p-6">
                <div className="mb-4 relative">
                  <div className="h-64 overflow-y-auto border rounded-lg p-4 bg-gray-50">
                    {response}
                    {loading && (
                      <div className="absolute inset-0 flex items-center justify-center bg-white/70">
                        <Loader />
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="space-y-4">
                  <textarea
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                    rows={3}
                    value={message}
                    onChange={(e) => onMessageChange(e.target.value)}
                    disabled={loading}
                    placeholder="Enter your message..."
                  />
                  
                  <div className="flex justify-end gap-3">
                    <button
                      onClick={onClose}
                      className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium rounded-lg transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={onSubmit}
                      className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  